import validate from "/home/node/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss+reset_xoqi6zlz6eq2gqnxrwiaifaa7i/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45old_45site_45global from "/home/node/middleware/01.old-site.global.ts";
import manifest_45route_45rule from "/home/node/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss+reset_xoqi6zlz6eq2gqnxrwiaifaa7i/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45old_45site_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}